<script setup lang="ts">
import { formatDate } from "@/helpers/date.helper";
import { ActiviteitLesWithTrainers } from "@/repositories/activiteit.repository";
import { computed, ref } from "vue";

const props = defineProps<{
    lessen: ActiviteitLesWithTrainers[] | null;
}>();

const sortedLessen = computed(() => {
    if (!props.lessen) {
        return [];
    }

    return [...props.lessen].sort((left, right) => {
        return new Date(left.BeginDatum).getTime() - new Date(right.BeginDatum).getTime();
    });
});

const openLessen = ref<Record<string, boolean>>({});

const getLesKey = (item: ActiviteitLesWithTrainers, index: number) => {
    return String(item.SportmomentLesId ?? index);
};

const isLesOpen = (key: string) => {
    return !!openLessen.value[key];
};

const toggleLes = (key: string) => {
    openLessen.value[key] = !isLesOpen(key);
};

const isLesStarted = (item: ActiviteitLesWithTrainers) => {
    return new Date(item.BeginDatum).getTime() < Date.now();
};
</script>

<template>
    <ul class="lesson-card-list list-unstyled" v-if="sortedLessen.length">
        <li
            :class="[
                'lesson-card',
                isLesStarted(item) ? 'lesson-card--started' : 'lesson-card--upcoming',
                { collapsed: !isLesOpen(getLesKey(item, index)) }
            ]"
            v-for="(item, index) in sortedLessen"
            :key="item.SportmomentLesId || index"
            @click="item.Beschrijving && toggleLes(getLesKey(item, index))"
        >
            <div class="lesson-card-wrapper ">

                <div class="lesson-card-header">
                    Les {{ index + 1 }}
                    <span v-if="isLesStarted(item)" class="lesson-card-status">
                        Afgelopen
                    </span>
                </div>
                <div class="lesson-card-content">
                    <div class="lesson-card-content-info">
                        <p class="info-title">
                            {{ item.Naam }}
                        </p>
                        <div class="info-date">
                            {{ formatDate(item.BeginDatum, {
                                weekday: "long", day: "2-digit", month: "long", year:
                                    "numeric"
                            }) }} ·
                            {{ formatDate(item.BeginDatum, { hour: "2-digit", minute: "2-digit" }) }} uur tot
                            {{ formatDate(item.EindDatum, { hour: "2-digit", minute: "2-digit" }) }} uur
                        </div>

                        <div
                            v-if="item.Beschrijving"
                            :class="['lesson-card-expand', 'collapse', { show: isLesOpen(getLesKey(item, index)) }]"
                        >
                            <div class="lesson-card-expand-info">
                                <div class="expand-wrapper">
                                    {{ item.Beschrijving }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="lesson-card-content-button" v-if="item.Beschrijving">
                        <div class="icon-wrapper">
                            <span class="icon icon-collapse"></span>
                        </div>
                    </div>
                </div>
            </div>
        </li>
    </ul>
</template>
